import { render, staticRenderFns } from "./ListProyek.vue?vue&type=template&id=df940b0a&scoped=true"
import script from "./ListProyek.vue?vue&type=script&lang=js"
export * from "./ListProyek.vue?vue&type=script&lang=js"
import style0 from "./ListProyek.vue?vue&type=style&index=0&id=df940b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df940b0a",
  null
  
)

export default component.exports